module.exports = __webpack_public_path__ + "img/boleto.e2e3cf93.svg";